import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Nanotechnology Foundations & Atomic-Scale Science",
    description:
      "Introduction to Nanotechnology, Scope evolution & impact, Understanding nanoscale: atoms molecules & quantum effects, Difference between micro nano & bulk materials, Applications in medicine electronics energy & environment, Real-world nanotech innovations shaping the future",
  },
  {
    title: "Nanomaterials: Types, Properties & Applications",
    description:
      "Carbon-based nanomaterials: graphene CNTs fullerenes, Metal & metal oxide nanoparticles, Quantum dots nanowires & nanocomposites, Optical electrical & mechanical properties of nanomaterials, Designing materials for real-world use cases",
  },
  {
    title: "Synthesis of Nanomaterials: Top-Down & Bottom-Up Techniques",
    description:
      "Chemical vapor deposition (CVD) & physical vapor deposition (PVD), Sol-gel method hydrothermal synthesis & chemical reduction, Mechanical milling & lithography, Controlled synthesis for predictable material properties, Laboratory-level nano fabrication workflow",
  },
  {
    title: "Characterization Tools & Nano-Scale Measurement Techniques",
    description:
      "Scanning Electron Microscopy (SEM), Transmission Electron Microscopy (TEM), Atomic Force Microscopy (AFM), XRD FTIR UV-Vis Raman spectroscopy, Understanding nanoscale structure surface & composition",
  },
  {
    title: "Nanobiotechnology & Medical Applications",
    description:
      "Nanoparticles in drug delivery & targeted therapy, Nano-diagnostics & biosensors, Tissue engineering & regenerative medicine, Applications in vaccines & cancer treatment, Safety & biocompatibility considerations",
  },
  {
    title: "Nanoelectronics & Advanced Device Fabrication",
    description:
      "Nano-transistors sensors & memory devices, Quantum dots in electronics, Flexible & wearable nanotechnology, Integration of nanomaterials in semiconductor manufacturing, Future trends: quantum computing & nano-chips",
  },
  {
    title: "Environmental Nanotechnology & Sustainability",
    description:
      "Nanoparticles for water purification, Air pollution sensors & filtration systems, Energy storage materials (supercapacitors & batteries), Photocatalysis & green nanotechnology, Reducing environmental impact with nano-solutions",
  },
  {
    title: "Safety, Toxicology & Ethical Guidelines in Nanotech",
    description:
      "Nanotoxicity & biological impact assessment, Safe handling of nanomaterials, Environmental safety protocols, Ethical social & legal implications, International safety standards & regulations",
  },
  {
    title: "Computational Nanotechnology & Simulation Tools",
    description:
      "Molecular dynamics (MD) basics, Simulation of nanoparticles & nanomaterials, Quantum modeling & nanoscale predictions, AI/ML applications in nanoscience, Software tools used in nanotech research",
  },
  {
    title: "Capstone Nanotechnology Project & Career Launchpad",
    description:
      "Designing and executing a nano-research project, Lab report writing & scientific documentation, Building a nanotech portfolio for industry/research, Resume & LinkedIn optimization for nanotech roles, Interview prep for Nanotechnology Researcher Material Scientist Nano Engineer",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
